import React from 'react';
import '../LandingPage/LandingPage.css';
import './CookiePolicyPage.css';

const CookiePolicyPage: React.FC = () => {
    return (
        <div className="policy-page">
            <div className="policy-content-container">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="policy-logo">
                    <path d="M15.578 9.01277C14.7616 8.19637 13.4808 8.03231 12.5632 8.73312C10.9429 9.97072 9.527 11.4624 8.37501 13.1487C7.74895 14.0651 7.93561 15.2837 8.72039 16.0685L15.4952 22.8433C16.227 23.5751 16.227 24.7614 15.4952 25.4932L8.95765 32.0308C8.15835 32.8301 7.98173 34.0772 8.6419 34.9948C9.83323 36.6506 11.2838 38.1075 12.9341 39.3059C13.8518 39.9723 15.1041 39.7976 15.9061 38.9957L20.7339 34.1679C21.7823 33.1194 22.3713 31.6974 22.3713 30.2147V18.1218C22.3713 16.6391 21.7823 15.2171 20.7339 14.1686L15.578 9.01277Z" fill="var(--text-primary)"/>
                    <path d="M38.9815 32.4231C39.798 33.2397 39.962 34.5208 39.2607 35.4384C38.0227 37.0583 36.5306 38.4738 34.8439 39.6253C33.9275 40.251 32.7093 40.0642 31.9247 39.2796L26.8132 34.1682C25.7648 33.1198 25.1758 31.6978 25.1758 30.215V18.1221C25.1758 16.6394 25.7648 15.2174 26.8132 14.1689L32.2616 8.72062C33.0607 7.92148 34.3075 7.74475 35.2251 8.40454C36.8813 9.59545 38.3385 11.0456 39.5374 12.6957C40.2042 13.6133 40.0295 14.866 39.2274 15.668L32.0518 22.8436C31.3201 23.5754 31.3201 24.7618 32.0518 25.4935L38.9815 32.4231Z" fill="var(--text-primary)"/>
                </svg>

                <h1>Cookie Policy</h1>

                <h2>How We Use Cookies and Local Storage</h2>
                <p>
                  We use cookies and similar technologies like local storage for a variety of reasons detailed below. Some are essential for the website to function, while others help us improve your experience and require your consent. Disabling these technologies often impacts site functionality and features.
                </p>
                
                <h2>The Items We Set</h2>
                
                <h3>Essential Items</h3>
                <p>These items are necessary for core website functionality and are always active. They do not store personally identifiable information.</p>
                <ul>
                    <li>
                        <p><strong>Account & Login:</strong> We use local storage to manage the signup/login process (e.g., temporary email storage for verification) and to keep you logged in as you navigate the site. These are typically cleared upon logout.</p>
                    </li>
                     {/* Consider if performance caching is truly essential or performance-enhancing (consent) */}
                    <li>
                         <p><strong>Performance caching:</strong> To improve loading times, we may temporarily cache non-sensitive data in local storage.</p>
                    </li>
                </ul>

                <h3>Non-Essential Items (Require Consent)</h3>
                <p>These items help us provide a better experience or understand site usage. They are only activated if you consent via our cookie banner.</p>
                <ul>
                    <li>
                        <p><strong>Site Preferences:</strong> If you consent, we use local storage to remember your preferences for how this site runs (e.g., appearance, workspace selections) for your future visits.</p>
                    </li>
                    <li>
                        <p><strong>Analytics and Improvement:</strong> If you consent, we use cookies or similar technologies to understand how users interact with our site (often aggregated and anonymized). This helps us analyze usage, improve features, and enhance user experience.</p>
                    </li>
                    <li>
                        <p><strong>Consent Preference:</strong> We use a cookie (typically named `textaCookieConsent`) to store your consent preference itself, so we don't have to ask you repeatedly.</p>
                    </li>
                </ul>
    
                <h2>Managing Your Preferences</h2>
                <p>
                    You can manage your consent preferences for non-essential items using the cookie banner that appears when you first visit our site. 
                </p>
                <p>
                    You can also prevent the setting of cookies or clear local storage by adjusting the settings on your browser (see your browser's Help section for instructions). Be aware that disabling essential items will affect site functionality. Clearing your cookies will also remove your stored consent preference, and you will be asked for consent again on your next visit.
                </p>

                <h2>More Information</h2>
                <p>
                   Hopefully, that has clarified things for you. If you are still looking for more information then you can contact us through our preferred contact methods.
               </p>
                <p>
                   For more general information on cookies, please read{" "}
                   <a href="https://www.privacypolicyonline.com/what-are-cookies/" target="_blank" rel="noopener noreferrer">
                       "What Are Cookies"
                   </a>.
                </p>
            </div>
        </div>
    );
};

export default CookiePolicyPage;
 